<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import Multiselect from 'vue-multiselect'

export default {

    page: {
        title: 'Новый словарь',
        meta: [{ name: 'description', content: appConfig.description }],
    },

    components: { Layout, PageHeader, Multiselect },

    data() {
        return {
            title: 'Новый словарь',
            items: [],
            trackBy: 'code',
            dictionary_uuid: '',
            user_phone: null,
            name: '',
            description: '',
            words_equal: [],
            words_equal_options: [],
            words_in: [],
            words_in_options: [],
            words_not_in: [],
            words_not_in_options: [],
            public: null
        }
    },

    computed: {
        dictionary_item(){
            return this.$store.getters['dictionaries/GET_DICTIONARIES_ITEM'];
        },
        session_user_item(){
            let session = this.$store.getters['sessions/GET_SESSIONS_ITEM'];
            return session.user ? session.user : null;
        },
    },

    async mounted() {

        this.dictionary_uuid = this.$route.params.dictionary_uuid ? this.$route.params.dictionary_uuid : '';

        if(this.dictionary_uuid !== ''){

            this.title = 'Редактирование словаря';
            document.title = appConfig.title + ' - ' + 'Редактирование словаря';

            let data_send = {
                'uuid' : this.dictionary_uuid,
            }
            await this.$store.dispatch('dictionaries/FETCH_DICTIONARIES_ITEM', data_send);

            this.name = this.dictionary_item.name ? this.dictionary_item.name : '';
            this.description = this.dictionary_item.description ? this.dictionary_item.description : '';

            let words_equal_list = this.dictionary_item.words_equal ? JSON.parse(this.dictionary_item.words_equal) : [];
            let words_in_list = this.dictionary_item.words_in ? JSON.parse(this.dictionary_item.words_in) : [];
            let words_not_in_list = this.dictionary_item.words_not_in ? JSON.parse(this.dictionary_item.words_not_in) : [];

            let words_equal = [];
            let words_in = [];
            let words_not_in = [];

            words_equal_list.forEach(el => {
                words_equal.push({ name: el, code: el });
            });

            words_in_list.forEach(el => {
                words_in.push({ name: el, code: el });
            });

            words_not_in_list.forEach(el => {
                words_not_in.push({ name: el, code: el });
            });

            this.words_equal = words_equal;
            this.words_equal_options = words_equal;

            this.words_in = words_in;
            this.words_in_options = words_in;

            this.words_not_in = words_not_in;
            this.words_not_in_options = words_not_in;
            
            this.public = this.dictionary_item.access && this.dictionary_item.access === 'public' ? true : false
        }
    },

    methods: {

        async saveItem(){

            let words_equal_save = [];
            let words_in_save = [];
            let words_not_in_save = [];

            this.words_equal.forEach(el => {
                words_equal_save.push(el.name);
            });

            this.words_in.forEach(el => {
                words_in_save.push(el.name);
            });

            this.words_not_in.forEach(el => {
                words_not_in_save.push(el.name);
            });

            let data_send = {
                'name'         : this.name,
                'description'  : this.description,
                'user_phone'   : this.user_phone,
                'words_equal'  : JSON.stringify(words_equal_save),
                'words_in'     : JSON.stringify(words_in_save),
                'words_not_in' : JSON.stringify(words_not_in_save),
                'access'       : this.public === true ? 'public' : null,
            };

            let result = '';

            if(this.dictionary_uuid === ''){
                result = await this.$store.dispatch('dictionaries/FETCH_DICTIONARIES_CREATE', data_send);
            } else {
                data_send.uuid = this.dictionary_uuid;
                result = await this.$store.dispatch('dictionaries/FETCH_DICTIONARIES_UPDATE', data_send);
            }

            if(result === false){
                alert('Возникла ошибка');
            } else {
                this.$router.push({ name: 'Dictionaries'});
            }
        },

        addWordsEqual (newTag) {

            newTag =  String(newTag)
            if(newTag.indexOf(';') === -1){
                const tag = {
                    name: newTag.trim(),
                    code: newTag.trim()
                }
                this.words_equal.push(tag);
            } else {
                let arr = newTag.split(';');
                arr.forEach(el => {
                    el = String(el);
                    this.words_equal.push({
                        name: el.trim(),
                        code: el.trim(),
                    });
                })
            }

            this.words_equal_options = this.words_equal;
        },
        addWordsIn (newTag) {
            newTag =  String(newTag)
            if(newTag.indexOf(';') === -1){
                const tag = {
                    name: newTag.trim(),
                    code: newTag.trim(),
                }
                this.words_in.push(tag);
            } else {
                let arr = newTag.split(';');
                arr.forEach(el => {
                    el = String(el);
                    this.words_in.push({
                        name: el.trim(),
                        code: el.trim(),
                    });
                })
            }
            this.words_in_options = this.words_in;
        },
        addWordsNotIn (newTag) {
            newTag =  String(newTag)
            if(newTag.indexOf(';') === -1){
                const tag = {
                    name: newTag.trim(),
                    code: newTag.trim(),
                }
                this.words_not_in.push(tag);
            } else {
                let arr = newTag.split(';');
                arr.forEach(el => {
                    el = String(el);
                    this.words_not_in.push({
                        name: el.trim(),
                        code: el.trim(),
                    });
                })
            }
            this.words_not_in_options = this.words_not_in;
        },
        async clear(type){
            if(type === 'words_equal'){
                this.words_equal = [];
                this.words_equal_options = [];
            }
            if(type === 'words_in'){
                this.words_in = [];
                this.words_in_options = [];
            }
            if(type === 'words_not_in'){
                this.words_not_in = [];
                this.words_not_in_options = [];
            }
        }
    },
}

</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <b-form
            class="form-horizontal"
            @submit.prevent="saveItem"
        >
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col">

                                <b-form-group
                                    label="Название"
                                    label-for="name"
                                >
                                    <b-form-input
                                        id="name"
                                        v-model="name"
                                        placeholder="Укажите название словаря"
                                    ></b-form-input>
                                </b-form-group>

                                <b-form-group
                                    label="Комментарий к словарю"
                                    label-for="description"
                                >
                                    <b-form-input
                                        id="description"
                                        v-model="description"
                                        placeholder=""
                                    ></b-form-input>
                                </b-form-group>

                                <br>

                                <div class="row mb-1">
                                    <div class="col-sm-12 col-xl-7">
                                        <p style="margin-top: 20px !important; margin-bottom: 0px !important; font-size: 0.875rem;; font-weight: 600">Фраза полностью совпадает</p>
                                    </div>
                                    <div class="col-sm-12 col-xl-5">
                                        <a href="#" @click.prevent="clear('words_equal')" id="clear_words_equal" class="btn btn-outline-secondary float-sm-right" style="margin-top: 10px; margin-left: 7px; margin-right: 0px">
                                            <b-tooltip target="clear_words_equal" placement="top">Очистить</b-tooltip>
                                            <i class="uil uil-trash"></i>
                                        </a>
                                    </div>
                                </div>
                                <b-form-group>
                                    <multiselect
                                        id="words_equal"
                                        :track-by="trackBy"
                                        v-model="words_equal"
                                        :options="words_equal_options"
                                        :multiple="true"
                                        :taggable="true"
                                        @tag="addWordsEqual"
                                        placeholder=""
                                        selectLabel="Нажмите, чтобы выбрать"
                                        deselectLabel="Нажмите, снять выделение"
                                        label="name"
                                    ></multiselect>
                                </b-form-group>

                                <div class="row mb-1">
                                    <div class="col-sm-12 col-xl-7">
                                        <p style="margin-top: 20px !important; margin-bottom: 0px !important; font-size: 0.875rem;; font-weight: 600">Фраза содержит</p>
                                    </div>
                                    <div class="col-sm-12 col-xl-5">
                                        <a href="#" @click.prevent="clear('words_in')" id="clear_words_equal" class="btn btn-outline-secondary float-sm-right" style="margin-top: 10px; margin-left: 7px; margin-right: 0px">
                                            <b-tooltip target="clear_words_equal" placement="top">Очистить</b-tooltip>
                                            <i class="uil uil-trash"></i>
                                        </a>
                                    </div>
                                </div>
                                <b-form-group>
                                    <multiselect
                                        id="words_in"
                                        :track-by="trackBy"
                                        v-model="words_in"
                                        :options="words_in_options"
                                        :multiple="true"
                                        :taggable="true"
                                        @tag="addWordsIn"
                                        placeholder=""
                                        selectLabel="Нажмите, чтобы выбрать"
                                        deselectLabel="Нажмите, снять выделение"
                                        label="name"
                                    ></multiselect>
                                </b-form-group>

                                <div class="row mb-1">
                                    <div class="col-sm-12 col-xl-7">
                                        <p style="margin-top: 20px !important; margin-bottom: 0px !important; font-size: 0.875rem;; font-weight: 600">Слова исключение</p>
                                    </div>
                                    <div class="col-sm-12 col-xl-5">
                                        <a href="#" @click.prevent="clear('words_not_in')" id="clear_words_equal" class="btn btn-outline-secondary float-sm-right" style="margin-top: 10px; margin-left: 7px; margin-right: 0px">
                                            <b-tooltip target="clear_words_equal" placement="top">Очистить</b-tooltip>
                                            <i class="uil uil-trash"></i>
                                        </a>
                                    </div>
                                </div>
                                <b-form-group>
                                    <multiselect
                                        id="words_not_in"
                                        :track-by="trackBy"
                                        v-model="words_not_in"
                                        :options="words_not_in_options"
                                        :multiple="true"
                                        :taggable="true"
                                        @tag="addWordsNotIn"
                                        placeholder=""
                                        selectLabel="Нажмите, чтобы выбрать"
                                        deselectLabel="Нажмите, снять выделение"
                                        label="name"
                                    ></multiselect>
                                </b-form-group>
                                <b-form-group label="Передать на аккаунт пользователя" label-for="user_phone" style="margin-top: 15px">
                                    <b-form-input id="user_phone" v-model="user_phone" placeholder="Укажите номер телефона"/>
                                </b-form-group>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12 col-xl-12">
                                <b-form-checkbox v-model="public" name="public" style="margin-top: 5px; margin-bottom: 5px" switch>
                                    Открыть публичный доступ к словарю
                                </b-form-checkbox>
                            </div>            
                        </div>                        
                    </div>
                    <hr style="margin-bottom: 0px !important; margin-top: 0px !important">
                    <div style="padding: 0.75rem">
                        <button type="submit" class="btn btn-primary">Сохранить</button>
                    </div>
                    <!-- end card-body -->
                </div>
                <!-- end card-->
            </div>
            <!-- end col -->
        </div>
        </b-form>
    </Layout>
</template>
